import qs from 'qs';

import type { PackageLabel } from '../../../../shared/model-typings/packagelabel';
import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';
import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';

type PackageLabelResponse = {
  packageLabels: PackageLabel[];
};

function getOrganizationPackageLabels() {
  return get<PackageLabelResponse>('/api/package-labels', true);
}

/**
 * Fetch all of the package labels that an organization has defined.
 */
export function useOrganizationPackageLabels() {
  return useQuery<PackageLabelResponse>({
    queryFn: () => getOrganizationPackageLabels(),
    queryKey: ['packageLabels'],
  });
}

type PackageLabelAssignmentResponse = {
  packageLabelAssignments: PackageLabelAssignmentWithName[];
};

function getPackageLabelAssignments(packageId: string, scopeId?: string) {
  const filterParams = {
    filters: {
      packageId: nuc(packageId),
      ...(scopeId ? { scopeId: nuc(scopeId) } : {}),
    },
  };
  const params = qs.parse(qs.stringify(filterParams));
  return get<PackageLabelAssignmentResponse>(`/api/package-label-assignments`, true, params);
}

/**
 * Fetch all of the package labels assigned to a dependency.
 */
export function usePackageLabelAssignments(packageId: string, scopeId?: string) {
  return useQuery<PackageLabelAssignmentResponse>({
    queryKey: ['packageLabels', packageId, scopeId],
    queryFn: () => getPackageLabelAssignments(packageId, scopeId),
  });
}
